export default __webpack_public_path__ + "static/media/eldor.0841f1e2.png";